import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import CommentSection from "../../../info-technology-process/commentsection/comment-sections";
import { useSelector } from "../../../../../store/store";
import { Skeleton, Form, Input } from "antd";
import { useGetDetailRequests } from "../hooks";
import { useEmployee } from "../../../../../hook";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { StyledTitle } from "../../../../../components/styled-antd/Title";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";
import { RenderApprovalHistory } from "../../../human-organization/summary-employee-request/utils/render-helper";
import { getApproverName, getEmployeeDetail } from "../../../human-organization/summary-employee-request/utils/get-employee-detail";

export const ExportHistory: FC<{ form: any , isEnableAccept:boolean}> = ({ form, isEnableAccept }) => {
  const user = useSelector((state) => state.user);
  const { data: detail, isLoading: isLoadingDetail } = useGetDetailRequests();
  const { data: employees, isLoading: isLoadingEmployees } = useEmployee();
  const { getITLeadITHeadAssignee } = useSoftwares();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const history = [
    {
      status: detail?.fields?.eApprovedStatus,
      name:
        detail?.fields?.eApprovedName ||
        getEmployeeDetail(
          detail?.fields?.eApprovedBy?.toLowerCase(),
          employees,
          softwares
        )?.[0]?.Title,
      approvedDate: detail?.fields?.eApprovedDate,
      title: "Thủ trưởng cơ quan đơn vị",
      comment: detail.fields?.eApprovalComment,
    },
    {
      status: detail?.fields?.eApprovedByITLeadStatus,
      // name: getITLeadITHeadAssignee(SystemCode.EWR)?.eAssignee?.split("|")?.[1],
      name:getApproverName(
        detail?.fields?.eApprovedByITLead,
        employees,
        softwares,
        getITLeadITHeadAssignee(SystemCode.EWR).eAssignee
      ),
      approvedDate: detail?.fields?.eApprovedByITLeadDate,
      title: "Bộ phận hành chính phòng KHĐT",
      comment: detail.fields?.eITLeadComment,
    },
  ];
  
  if (isLoadingDetail || isLoadingEmployees) return <Skeleton />;

  return (
    <>
      <Box title="Lịch sử phê duyệt">
        <div className="py-2 pl-3">
          <p>
            <span className="font-weight-bold">
              {detail?.createdBy?.user?.displayName}
            </span>{" "}
            đã tạo lúc {getDDMMYYYFormat(detail?.createdDateTime)} -{" "}
            {getHHmmFormat(detail?.createdDateTime)}
          </p>
        </div>

        <RenderApprovalHistory history={history} />

        <Form form={form}>
          <Form.Item name="comment">
            <StyledTitle level={5}>Comments</StyledTitle>
            <Input.TextArea
              onChange={(e) => {
                form.setFieldsValue({
                  comment: e.target.value,
                });
              }}
              disabled={!isEnableAccept}
            />
          </Form.Item>
        </Form>
      </Box>
      
      <Box title="Thông tin trao đổi">
        <CommentSection
          comments={[]}
          data={detail}
          user={user}
          id={13}
          className="mb-4"
        />
      </Box>
    </>
  );
};
